import { config } from './reducer';
import { sagas } from './sagas';


export * from './hooks';

export const state = {
    reducer: {
        config,
    },
    sagas,
};
